import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = {
    open: { type: Boolean, default: true }
  }

  connect() {
    this.isOpen = this.openValue
    if (this.isOpen) {
      this.contentTarget.classList.add("open")
    }
  }

  toggle(event) {
    this.isOpen = !this.isOpen
    this.contentTarget.classList.toggle("open")
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }

  // Empêche la propagation du clic (pour les éléments interactifs dans le header)
  stop(event) {
    event.stopPropagation()
  }
}
